import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {OwlOptions} from "ngx-owl-carousel-o";
import { Metric } from 'src/app/interfaces/engagement-details.interface';
import { KeyMetricesResponse, RevenueAndMarginData, RevenueData } from 'src/app/pages/home/components/revenue-potential/key-metrices.interface';
import { HomeService } from 'src/app/services/home/home.service';

@Component({
  selector: 'app-key-metrics',
  templateUrl: './key-metrics.component.html',
  styleUrls: ['./key-metrics.component.scss']
})
export class KeyMetricsComponent implements OnInit {
  showMetricLoader = false;
  showMetricChartLoader = false;
  metrics: Metric[] = [];
  selectedMetric!: Metric;
  chartData: any;
  clientId: any = "";
  public persona: string = '';
  @Input() data: any = {
    'clientId': '',
    'name': ''
  };
  carouselOptions: OwlOptions = {
    items: 4,
    margin: 10,
    loop: true,
    dots: false,
    nav: false,
    rewind: true,
    autoWidth: true,
  }
  isCarouselSlideDragging = false;

  constructor(private route: ActivatedRoute, private homeServiceRef: HomeService, private router:Router) {}

  ngOnInit(): void {
    this.homeServiceRef.persona$.subscribe(persona => {
      this.persona = persona;
      this.getAllMetrics();
    });  
  }

  getAllMetrics(): void {
    if (this.showMetricLoader) {
      return;
    }
    
    this.showMetricLoader = true;
    this.homeServiceRef.getKeymetricsList(this.data.clientId, this.data.name).subscribe((res) => {
      
      this.metrics = res.metrics
        .filter((metric: string) => {
          return res.persona[metric].includes(this.persona)
        })
        .map((metric: string) => {
          return { label: metric }
        });
      this.showMetricLoader = false;
      this.showMetricChartLoader = false;
      if (this.metrics.length > 0) {
        this.onCarouselSlideItemClick(this.metrics[0]);
      }
    })

    
    // Call API here [Remove the below metrics data with the actual API response]
    // setTimeout(() => {
    //   this.metrics = [
    //     {label: "SLA"},
    //     {label: "Audit Finding"},
    //     {label: "Revenue & Margin"},
    //     {label: "Financial Accuracy"},
    //     {label: "CSAT"},
    //     {label: "Total Budget"},
    //     {label: "Business Process Improvement"},
    //     {label: "Compliance Rate"},
    //     {label: "Invoicing Status"},
    //   ]
    //   this.showMetricLoader = false;
    //   this.onCarouselSlideItemClick(this.metrics[0])
    // }, 500);
  }

  onCarouselSlideItemClick(metric: Metric): void {
    if (this.showMetricChartLoader) {
      return;
    }
    this.selectedMetric = metric;
    this.getMetricChartData();
  }

  getMetricChartData(): void {
    this.showMetricChartLoader = true;
    this.homeServiceRef.getKeymetricsDetails(this.data.clientId, this.data.name, this.selectedMetric.label).subscribe((res: KeyMetricesResponse) => {
      console.log(res.data);
      if (this.selectedMetric.label === "Revenue&Margin") {
        this.chartData = (res.data as RevenueAndMarginData[]).map(data => ({
          revenueGenerated: data.revenueGenerated,
          incurredCost: data.incurredCost,
          period: this.formatPeriod(data.period),
          isProjected: data.isProjected,
          clientIdentifier: res.clientIdentifier,
          marginPercentage: data.marginPercentage,
        }));
      } else {
        this.chartData = (res.data as RevenueData[]).map(data => ({
          value: data.value,
          period: this.formatPeriod(data.period),
          isProjected: data.isProjected,
        }));
      }
      this.showMetricLoader = false;
      this.carouselOptions = { ...this.carouselOptions, loop: false }
      this.showMetricChartLoader = false;
    })
  }
  private formatPeriod(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleString('default', { month: 'short', year: 'numeric' });
  }
  onCarouselSlideDragging(event: any): void {
    //  setTimeout(() => {
    //    this.isCarouselSlideDragging = event.dragging
    //  });
    }
}
